import { createSlice } from '@reduxjs/toolkit';
import { Exception } from 'exception/Exception';
import { deleteTrend, fetchTrendDataList, uploadTrendData } from 'reduxStore/trend/asyncActions';

import { STORE_NAME, TrendState } from './initialState';

export const trendSlice = createSlice({
  name: STORE_NAME,
  initialState: TrendState.INITIAL_DOMAIN,
  reducers: {
    clearErrors: (state) => {
      state.errors = TrendState.INITIAL_DOMAIN.errors;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrendDataList.fulfilled, (state, action) => {
        state.list = action.payload;
      })

      .addCase(deleteTrend.fulfilled, (state, action) => {
        // removing trend locally on deleteTrend.fulfilled
        state.list = state.list.filter((item) => item.id !== action.payload);
      })

      .addCase(uploadTrendData.fulfilled, (state, action) => {
        state.list = [action.payload, ...state.list];
        state.errors = null;
      })

      .addCase(uploadTrendData.rejected, (state, action) => {
        state.errors = (action.payload as Exception).getExceptionList();
      });
  },
});

export const { clearErrors } = trendSlice.actions;
